import React from "react";
import { CredentialLayout } from "../CredentialLayout";
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialProps } from "../CredentialProps";

interface GCPViewPageProps extends NSARouterMakerResult, CredentialProps { }

class GCPViewPage extends React.Component<GCPViewPageProps>
{
	override render()
	{
		return (
			<CredentialLayout
				{...this.props}
				action={{
					description: "This section shows the full details of a Google Cloud Platform (GCP) credential, including its name and the service account key it stores as a secret. You can review its history and tags and copy any field, while the secret value stays protected."
				}}
				pages={{
					entity: CredentialEntities.gcp(this.props),
					view: {}
				}}
			>
				<></>
			</CredentialLayout>
		);
	}
}

export default GCPViewPage;